const crossPageNotifications = {
  notificationMessageUpdate: "notificationMessageUpdate",
  releaseNotesUpdate: "releaseNotesUpdate"
};

export default crossPageNotifications;
